// extracted by mini-css-extract-plugin
export var active = "_kt-2";
export var recordingDot = "_kt-1";
export var recordingIndicator = "_kt-0";